<template>
<div class="shopping-cart--user">
    <div class="row">
        <div class="col-12 text-center frameTitleGreen" v-html="$t('cart.user.title')"></div>
    </div>
    <div class="row justify-content-center loginFrame">
        <div class="col-12 col-md-4">
            <div class="titleLogin">{{$t('auth.login.title')}}</div>
            <form class="form-horizontal" method="POST" action="/login">
                <input-field :label="$t('auth.login.email')" v-model="credentials.email" type="email" name="email" :required="true" :errors="loginErrors"></input-field>
                <input-field :label="$t('auth.login.password')" v-model="credentials.password" type="password" name="password" :required="true" :errors="loginErrors"></input-field>
                <div class="row justify-content-center">
                    <div class="col-9">
                        <button type="submit" @click.prevent="login(credentials)" class="btn btn-outline-green w-100">
                            {{$t('auth.login.btn')}}
                        </button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 text-right">
                        <a href="/password/reset">{{$t('auth.login.forgot')}}</a>
                    </div>
                </div>
            </form>
        </div>
        <div class="col-12 col-md-1"></div>
        <div class="col-12 col-md-5">
            <div class="titleNewUser">{{$t('cart.user.new_user')}}</div>
            <div class="row justify-content-center">
                <div class="col-12 col-md-8">
                    <div class="margin-bottom-20">{{$t('cart.user.text_advantages_title')}}</div>
                    <div class="advantage" v-if="$t('cart.user.text_advantages_1') != ''"><div class="icon icon-check-mark"></div>{{$t('cart.user.text_advantages_1')}}</div>
                    <div class="advantage"><div class="icon icon-check-mark"></div>{{$t('cart.user.text_advantages_2')}}</div>
                    <div class="advantage"><div class="icon icon-check-mark"></div>{{$t('cart.user.text_advantages_3')}}</div>
                    <div class="advantage"><div class="icon icon-check-mark"></div>{{$t('cart.user.text_advantages_4')}}</div>
                    <div class="advantage"><div class="icon icon-check-mark"></div>{{$t('cart.user.text_advantages_5')}}</div>
                    <button type="submit" class="btn btn-outline-green w-100" @click.prevent="registerUser">
                        {{$t('cart.user.register')}}
                    </button>
                </div>
            </div>
        </div>
        <div class="col-12 col-md-10">
            <hr>
        </div>
        <div class="col-12 col-md-10">
            {{$t('cart.user.no_registration_text')}} <button type="submit" class="btn btn-outline-green noReg" @click.prevent="registerGuest">{{$t('cart.user.no_registration_btn')}}</button>
        </div>
    </div>
</div>
</template>


<script>

import Vue from 'vue'
import InputField from '@Components/checkout/modules/InputField'
import { createNamespacedHelpers as nsHelper } from 'vuex'
import { RegistrationType } from './'
import SmoothScroll from 'smooth-scroll'

const scroll = new SmoothScroll()

const {
    mapState: mapUserState,
    mapActions: mapUserActions,
    mapGetters: mapUserGetters,
} = nsHelper('user')

export default {

    components: {
        InputField
    },

    computed: {
        ...mapUserState(['user', 'loading', 'loginErrors'])
    },

    created() {
    },

    data() {
        return {
            credentials: {
                email: null,
                password: null
            }
        }
    },

    methods: {
        ...mapUserActions(['login']),

        registerUser() {
            this.$emit('register', {
                type: RegistrationType.USER
            });
            Vue.nextTick(() => {
                var el = document.querySelector('.shopping-cart--register')
                scroll.animateScroll(el, null, {
                    offset: anchor => document.body.className === 'is-scrolling' ? 125 : 175
                })
            })
        },

        registerGuest() {
            this.$emit('register', {
                type: RegistrationType.GUEST
            });
            Vue.nextTick(() => {
                var el = document.querySelector('.shopping-cart--register')
                scroll.animateScroll(el, null, {
                    offset: anchor => document.body.className === 'is-scrolling' ? 125 : 175
                })
            })
        }
    },


}
</script>
